import { Injectable } from '@angular/core';
import { MotorVehiclesToReplace } from '@app/salesfunnel/interfaces';
import { ApiProductIdEnum, PolicyProductIdEnum, RequestService } from 'outshared-lib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class ReplacementSalesfunnelService {

    constructor(private request: RequestService) {}

    public getReplacementVehicles$(productId: PolicyProductIdEnum): Observable<MotorVehiclesToReplace> {
        const payload = {
            product_id: this.mapProductIdRequest(productId),
        };

        return this.request.post('en-gb/relation-general/request/motor_vehicles_to_replace', payload)
            .pipe(map((response) => response.data));
    }

    // TODO: WINS-7636 move mapper function to outshared-lib
    private mapProductIdRequest(response: PolicyProductIdEnum): ApiProductIdEnum {
        if (!response) {
            return null;
        }

        switch (response) {
        case PolicyProductIdEnum.Liability:
            return ApiProductIdEnum.Liability;
        case PolicyProductIdEnum.Car:
            return ApiProductIdEnum.Car;
        case PolicyProductIdEnum.Moped:
            return ApiProductIdEnum.Moped;
        case PolicyProductIdEnum.Scooter:
            return ApiProductIdEnum.Scooter;
        case PolicyProductIdEnum.Caravan:
            return ApiProductIdEnum.Caravan;
        case PolicyProductIdEnum.Bicycle:
            return ApiProductIdEnum.Bicycle;
        case PolicyProductIdEnum.Pet:
            return ApiProductIdEnum.Pet;
        case PolicyProductIdEnum.Motorcycle:
            return ApiProductIdEnum.Motorcycle;
        case PolicyProductIdEnum.Accidents:
            return ApiProductIdEnum.Accidents;
        case PolicyProductIdEnum.LegalAssistance:
            return ApiProductIdEnum.LegalAssistance;
        case PolicyProductIdEnum.Travel:
            return ApiProductIdEnum.Travel;
        case PolicyProductIdEnum.Home:
            return ApiProductIdEnum.Home;
        case PolicyProductIdEnum.Furniture:
            return ApiProductIdEnum.Furniture;
        case PolicyProductIdEnum.Building:
            return ApiProductIdEnum.Building;
    }
    }
}
